import { useMe } from '../api';
import { UserRole } from '../constants';

const useCheckAuth = () => {
  const { data, isLoading, isSuccess, isError, error } = useMe();
  return {
    username: data?.username,
    email: data?.email,
    apps: data?.apps,
    permissions: data?.permissions ?? [],
    role: data?.role,
    error,
    isError,
    isLoading,
    isSuccess,
    isSuperuser: data?.role === UserRole.SUPERUSER,
    isStaff: data?.role === UserRole.STAFF,
    isUserTracking: data?.hotjar_init,
    isAuthenticated: data && data?.auth,
  };
};

export default useCheckAuth;